'use strict';

function AddProcedureController($scope, $mdDialog, procedureTemplates) {
    'ngInject';

    $scope.procedureTpls = procedureTemplates;
    $scope.btnDisabled = true;

    $scope.selectedProcedureTpl = function(procedureTpl) {
        $mdDialog.hide({
            procedureTpl: procedureTpl
        });
    };

    $scope.querySearch = function(text) {
        let matches = this.procedureTpls.filter(pt => {
            let idMatches = pt.id.toString() == text;
            let nameMatches = pt.name.toLowerCase()
                .indexOf(text.toLowerCase()) > -1;
            return idMatches || nameMatches;
        });
        console.debug(matches);
        return matches;
    };

    $scope.cancel = function() {
        $mdDialog.cancel();
    };

    $scope.updateFormStatus = function() {
        if ($scope.procedureTpl) {
            $scope.btnDisabled = false;
        } else {
            $scope.btnDisabled = true;
        }
    };
}

export default AddProcedureController;
